// import * as textosUsuarioSelectors from './textos-usuario'
import * as barraHerramientasSelectors from './barra-herramientas';
import * as relojSelectors from './reloj';
import * as sesiones from '../gestor-sesiones/selectors'; // export { textosUsuarioSelectors } 

export { barraHerramientasSelectors };
export { relojSelectors };
export { sesiones };
export var getCaducado = function getCaducado(state) {
  return state.caducado;
};
export var getPantallas = function getPantallas(state) {
  return state.pantallas;
};
export var getPantalla = function getPantalla(state) {
  return state.pantalla;
};
export var getPantallaProps = function getPantallaProps(state, pantallaId) {
  if (pantallaId) {
    return state.pantallaProps[pantallaId];
  }

  return state.pantallaProps[state.pantalla];
};
export var getConfigGeneral = function getConfigGeneral(state) {
  return state.configGeneral;
};
export var getConfigPortada = function getConfigPortada(state) {
  return state.configPortada;
};
export var getConfigIndice = function getConfigIndice(state, libroId) {
  return libroId ? state.configIndice[libroId] : state.configIndice;
};
export var getPrimeraVentana = function getPrimeraVentana(state) {
  return state.primeraVentana;
};
export var getImagenUsuarioVisible = function getImagenUsuarioVisible(state) {
  return state.imagenUsuarioVisible;
};
export var getTextosUsuarioVisible = function getTextosUsuarioVisible(state) {
  return state.textosUsuarioVisible;
};
export var getConfigLibros = function getConfigLibros(state) {
  return state.configLibros;
};
export var getConfigCaminos = function getConfigCaminos(state) {
  return state.configCaminos;
};